import type { FC } from 'react';
import { ArrowDownRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const LowBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-transparent bg-warning text-white">
      {t('component:badge.low')}
      <ArrowDownRight aria-hidden className="size-3 shrink-0" />
    </Badge>
  );
};
